import dotProp from 'dot-prop-immutable';
import * as types from 'live/redux/actionTypes';

import { LIVE_ACTIVE_UPDATE } from 'shared/constants/StompKind';
import { STOMP_RECEIVE_DATA } from 'shared/redux/actionTypes';

const defaultSubState = {
  error: undefined,
  list: [],
  loading: false,
  totalPages: 0,
};

const defaultState = {
  active: defaultSubState,
  completed: defaultSubState,
};

const gameReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case types.LIVE_GAMES_REQUEST: {
      const { type } = action.meta;

      return {
        ...state,
        [type]: dotProp.set(defaultSubState, 'loading', true),
      };
    }

    case types.LIVE_GAMES_CLEAR: {
      return defaultState;
    }

    case types.LIVE_GAMES_RECEIVE: {
      const { type } = action.meta;
      const { content, totalPages } = action.payload;

      return {
        ...state,
        [type]: {
          ...defaultSubState,
          list: content,
          totalPages,
        },
      };
    }

    case types.LIVE_GAMES_ERROR: {
      const { type } = action.meta;
      const error = action.payload;

      return {
        ...state,
        [type]: dotProp.set(defaultSubState, 'error', error.message),
      };
    }

    case types.LIVE_GAME_DELETE_RECEIVE: {
      const { id, type } = action.meta;
      const list = state[type].list.filter(g => g.id !== id);

      return {
        ...state,
        [type]: dotProp.set(state[type], 'list', list),
      };
    }

    case STOMP_RECEIVE_DATA: {
      const { kind, data } = action.payload;

      if (kind === LIVE_ACTIVE_UPDATE && data.game) {
        const { game } = data;
        const type = game.isActive ? 'active' : 'completed';

        switch (data.action) {
          case 'delete': {
            const newState = state[type].list.filter(g => g.id !== game.id);

            return dotProp.set(state, `${type}.list`, newState);
          }
          case 'new': {
            const newState = [game, ...state[type].list];

            return dotProp.set(state, `${type}.list`, newState);
          }
          case 'update': {
            const { list } = state[type];
            const index = list.findIndex(g => g.id === game.id);
            const currentGame = dotProp.get(state, `${type}.list.${index}`);

            const updatedGame = {
              ...currentGame,
              ...game,
            };

            if (game.isActive !== currentGame.isActive) {
              const otherType = type === 'active' ? 'completed' : 'active';

              return {
                [type]: dotProp.delete(state[type], `list.${index}`),
                [otherType]: dotProp.set(state[otherType], `list`, [
                  ...state[otherType].list,
                  updatedGame,
                ]),
              };
            } else {
              return dotProp.set(state, `${type}.list.${index}`, updatedGame);
            }
          }

          default:
          // Do nothing
        }
      }

      return state;
    }

    default:
      return state;
  }
};

export default gameReducer;
